import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { useData } from '../../context/DataContext';
import './Exams.css';

const Exams = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { getStudentGrades } = useData();

  const userId = user?.id || user?._id;
  const grades = getStudentGrades(userId);

  const assessments = grades.map(g => ({
    id: g.id,
    examType: g.examType || 'other',
    course: g.course,
    score: g.score,
    grade: g.grade,
    status: g.status,
    date: g.gradeDate
  }));

  return (
    <div className="exams-page">
      <div className="page-header">
        <h1>{t('nav.exams')}</h1>
      </div>

      <div className="exams-list">
        {assessments.map((exam) => {
          return (
            <div key={exam.id} className="exam-card">
              <div className="exam-header">
                <h3>{exam.course?.name || '-'}</h3>
                <span className="exam-type">
                  {t(`exam.${exam.examType}`)}
                </span>
              </div>
              
              <div className="exam-course">
                <span className="course-name">{exam.course?.code || '-'}</span>
                <span className="course-code">{exam.date ? new Date(exam.date).toLocaleDateString() : '-'}</span>
              </div>

              <div className="exam-details">
                <div className="detail-row">
                  <span className="detail-label">{t('grade.grade')}:</span>
                  <span className="detail-value">{typeof exam.grade === 'number' ? `${exam.grade.toFixed(1)}/10` : '-'}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">{t('grade.score')}:</span>
                  <span className="detail-value">{typeof exam.score === 'number' ? `${exam.score}%` : '-'}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">{t('common.status')}:</span>
                  <span className="detail-value">{t(`grade.${exam.status}`)}</span>
                </div>
              </div>
            </div>
          );
        })}
        
        {assessments.length === 0 && (
          <div className="no-exams">
            <p>{t('common.noData')}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Exams;
